import { FC } from 'react';

import CapsuleTypeEditComponent from 'components/main/CapsuleType/Edit';

const CapsuleTypeEdit: FC = () => <CapsuleTypeEditComponent />;

export default CapsuleTypeEdit;
